export const facingModes = {
  ENVIRONMENT: 'ENVIRONMENT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  USER: 'USER',
};



// WEBPACK FOOTER //
// ./src/camera/facingModeTypes.js